import {IntermediatePart} from "../../intermediatePart";
import {PLACEMENTS} from "../../constants";
import Cabinet from "../../parts/cabinet";

export default class Faucet extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'faucet';
    this.partName = 'Faucet';
    this.translateId = "visualizer.kitchen.countertop.faucet";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    if (dbFeature.metaData && dbFeature.metaData["Placement"]
      && !dbFeature.metaData["Placement"].includes(PLACEMENTS.Countertop)) {
      return false
    }
    return super.load_(dbFeature, new Faucet());
  }

  disabledClick() {
    const relatedSink = this.getParent().sink;
    if (relatedSink) {
      relatedSink.disabled = this.disabled;
    }
  }

  setLayers(layout) {

    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    const bottomCabinet = cabinetParent && cabinetParent.bottomCabinet;
    if (bottomCabinet && (bottomCabinet.disabled || !bottomCabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    return [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.CountertopGroup.Faucet;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
